import { globalConstants } from "../constants";
import {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
  formDataPostRequest,
  formDataPutRequest
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getAll(gridData, projectId) {
  const orderBy = gridData.orderBy ? gridData.orderBy : "Id desc";
  return getRequest(
    `Candidate/all/${projectId}?pageNumber=${gridData.pageNumber}&pageSize=${gridData.length}&orderBy=${orderBy}&filterExpression=${gridData.filterExpression}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getById(id) {
  return getRequest(
    `Candidate/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAllCandidateList() {
  return getRequest(
    `Candidate/list`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function deleteById(id) {
    return deleteRequest(
    `Candidate/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function create(data) {
    return formDataPostRequest(
    `Candidate/create`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function update(data) {
    return formDataPutRequest(
    `Candidate`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function uploadCandidateExcel(data) {
    return formDataPostRequest(
    `Candidate/uploadExcel`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const candidateService = {
  getAll,
  getById,
  deleteById,
  create,
  update,
  getAllCandidateList,
  uploadCandidateExcel
};
